import chroma from "chroma-js";

import { analagousDecreasing, analagousIncreasing, triadDecreasing, triadIncreasing } from "Utilities/Colors/gradientGeneration/hue";
import { monochromatic } from "Utilities/Colors/gradientGeneration/monochromatic";

/**
 * @param {string} color 
 */
export function getPickerGradients(color) {
  const c = chroma(color);
  const [, , h] = c.oklch();
  
  if (h <= 105 || h >= 335) {
    return [
      monochromatic({ color }),
      analagousIncreasing({ color }),
      analagousDecreasing({ color }),
      triadDecreasing({ color }),
    ];
  }

  return [
      monochromatic({ color }),
      analagousIncreasing({ color }),
      analagousDecreasing({ color }),
      triadIncreasing({ color }),
    ];


}